import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Engage from "./pages/Engage";
import Governance from "./pages/Governance";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Marketplace from "./pages/Marketplace";
import MarketPlace from "./pages/MarketPlaceHub";
import SellerStorefront from "./pages/SellerStorefront";
import AdminMarket from "./pages/AdminMarket";
import PaperDetail from "./pages/PaperDetail";
import Programs from "./pages/Programs";
import ProgramDetail from "./pages/ProgramDetail";
import MembershipPlans from "./pages/MembershipPlans";
import MembershipRegister from "./pages/MembershipRegister";
import MembershipPayment from "./pages/MembershipPayment";
import MembershipApplication from "./pages/MembershipApplication";
import MembershipNextSteps from "./pages/MembershipNextSteps";
import PaymentSuccess from "./pages/PaymentSuccess";
import FlexiblePayment from "./pages/FlexiblePayment";
import MemberDashboard from "./pages/MemberDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AdminOverview from "./pages/AdminOverview";
import EditPaper from "./pages/EditPaper";
import UploadPaper from "./pages/UploadPaper";
import UserDashboard from "./pages/UserDashboard";
import AdminAnalytics from "./pages/AdminAnalytics";
import AuthorManagement from "./pages/AuthorManagement";
import AdminSchemes from "./pages/AdminSchemes";
import AddEditScheme from "./pages/AddEditScheme";
import ResearchInsights from "./pages/ResearchInsights";
import MonitoringEvaluation from "./pages/MonitoringEvaluation";
import PolicyAdvocacy from "./pages/PolicyAdvocacy";
import FundingOptions from "./pages/FundingOptions";
import FundDetail from "./pages/FundDetail";
import MemberDocuments from "./pages/MemberDocuments";
import MembersDirectory from "./pages/MembersDirectory";
import AdminMembers from "./pages/AdminMembers";
import MemberProfile from "./pages/MemberProfile";
import AdminMembershipPlans from "./pages/AdminMembershipPlans";
import AdminDownloads from "./pages/AdminDownloads";
import AdminExperts from "./pages/AdminExperts";
import MyEngagements from "./pages/MyEngagements";
import Events from "./pages/Events";
import AdminDialogues from "./pages/AdminDialogues";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Main site routes with Header/Footer wrapper */}
            <Route path="/" element={<><Header /><Home /><Footer /></>} />
            <Route path="/engage" element={<><Header /><Engage /><Footer /></>} />
            <Route path="/governance" element={<><Header /><Governance /><Footer /></>} />
            <Route path="/about" element={<><Header /><Home /><Footer /></>} />
            <Route path="/work" element={<><Header /><Home /><Footer /></>} />
            <Route path="/research" element={<Navigate to="/research-library" replace />} />
            <Route path="/monitoring" element={<MonitoringEvaluation />} />
            <Route path="/policy" element={<PolicyAdvocacy />} />
            <Route path="/partnerships" element={<><Header /><Home /><Footer /></>} />
            
            {/* Auth routes (standalone pages with their own layout) */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            
            {/* Marketplace routes (have Header/Footer inside their components) */}
            <Route path="/marketplace" element={<MarketPlace />} />
            <Route path="/marketplace/seller/:id" element={<SellerStorefront />} />
            <Route path="/research-library" element={<Marketplace />} />
            <Route path="/research-library/paper/:id" element={<PaperDetail />} />
            <Route path="/marketplace/paper/:id" element={<PaperDetail />} />
            
            {/* Programs routes */}
            <Route path="/programs" element={<Programs />} />
            <Route path="/programs/:id" element={<ProgramDetail />} />
            
            {/* Membership routes */}
            <Route path="/membership" element={<MembershipPlans />} />
            <Route path="/membership/register" element={<MembershipRegister />} />
            <Route path="/membership/application" element={<MembershipApplication />} />
            <Route path="/membership-next-steps" element={<MembershipNextSteps />} />
            <Route path="/membership/payment" element={<MembershipPayment />} />
            <Route path="/membership/payment-success" element={<PaymentSuccess />} />
            <Route path="/membership/dashboard" element={<MemberDashboard />} />
            <Route path="/membership/documents" element={<MemberDocuments />} />
            <Route path="/membership/profile" element={<MemberProfile />} />
            <Route path="/members" element={<MembersDirectory />} />
            <Route path="/my-engagements" element={<MyEngagements />} />
            <Route path="/events" element={<Events />} />
            
            {/* Flexible Payment Gateway */}
            <Route path="/payment" element={<FlexiblePayment />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />

            {/* Funding Options routes */}
            <Route path="/funding-options" element={<><Header /><FundingOptions /><Footer /></>} />
            <Route path="/funding-options/:fundId" element={<><Header /><FundDetail /><Footer /></>} />
            
            {/* Admin routes - New Unified Dashboard */}
            <Route path="/admin" element={<AdminOverview />} />
            <Route path="/admin/members" element={<AdminMembers />} />
            <Route path="/admin/membership" element={<AdminMembershipPlans />} />
            <Route path="/admin/downloads" element={<AdminDownloads />} />
            <Route path="/admin/experts" element={<AdminExperts />} />
            <Route path="/admin/dialogues" element={<AdminDialogues />} />
            <Route path="/admin/market" element={<AdminMarket />} />
            <Route path="/admin/old-dashboard" element={<AdminDashboard />} />
            <Route path="/admin/upload" element={<UploadPaper />} />
            <Route path="/admin/edit-paper/:id" element={<EditPaper />} />
            <Route path="/admin/analytics" element={<AdminAnalytics />} />
            <Route path="/admin/authors" element={<AuthorManagement />} />
            <Route path="/admin/schemes" element={<AdminSchemes />} />
            <Route path="/admin/schemes/add" element={<AddEditScheme />} />
            <Route path="/admin/schemes/edit/:id" element={<AddEditScheme />} />
            
            {/* User routes */}
            <Route path="/user/dashboard" element={<UserDashboard />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
